<template>
  <div class="locations">
    <div class="controls">
      <FilterLocations></FilterLocations>
    </div>
  </div>
</template>

<script>
import FilterLocations from '@/components/FilterLocations'

export default {
  name: 'locations',

  components: {
    'FilterLocations': FilterLocations
  },

  mounted: function () {
    this.$store.dispatch('locationsView/setFilters')
    this.$store.dispatch('locationsView/fetchLocations', this.filters)
  },

  computed: {
    filters () {
      return this.$store.getters['locationsView/filters']
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('locationsView/resetResults')
      this.$store.dispatch('locationsView/fetchLocations', this.filters)
    }
  }
}
</script>

<style lang="scss">
@import "../sass/components/locations.scss";
</style>



// WEBPACK FOOTER //
// Locations.vue?14afc209